import { IGetBetPositionRequest } from '../../../../../services/auction/getBetPosition';
import { IAuctionState, IOfferState } from '../../../../reducers';
import { ECategory, EConcurrencyType, EGeoType, EService } from '../../../../reducers/betPosition';

interface IGetBetPositionParams {
  serviceId: string;
  auction: IAuctionState;
  offer: IOfferState;
}

const SERVICE_MAP: { [service: string]: EService } = {
  top3: EService.Top3,
  premium: EService.Premium,
  paid: EService.Paid,
  free: EService.Free,
  'paid+highlight': EService.Paid,
  'premium+highlight': EService.Premium,
};

export function getBetPositionParams(params: IGetBetPositionParams): IGetBetPositionRequest {
  const {
    serviceId,
    auction: { currentBet },
    offer: { category, id, bargainTerms, geo },
  } = params;

  const service = SERVICE_MAP[serviceId];
  const geoId = geo?.geoId || undefined;
  const geoType = (geo?.geoType as EGeoType) || undefined;

  return {
    bet: currentBet,
    concurrencyType: EConcurrencyType.Local,
    announcementId: id,
    price: bargainTerms.price,
    geoId,
    geoType,
    category: category as ECategory,
    service,
  };
}
